import { SkuDetail } from '../../models/SkuDetail';
import { UseCase } from '../UseCase';
import { SkuRepository } from '../../repositories/SkuRepository';

export class GetSkuDetailAfterActivationUseCase implements UseCase<GetSkuDetailAfterActivationRequestDto, SkuDetail>{
    constructor(
        private skuRepo: SkuRepository
    ) { }
    execute(t: GetSkuDetailAfterActivationRequestDto): Promise<SkuDetail> {
        return this.skuRepo.getSkuDetailAfterActivation(t.sku, t.token, t.ref);
    }
}

export class GetSkuDetailAfterActivationRequestDto {
    constructor(
        public sku: string,
        public token: string,
        public ref: string
    ) { }
}
